import * as React from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'

import Layout from '../../../../components/ui/Layout/Layout'
import LinkButton from '../../../../components/ui/LinkButton/LinkButton'

import ReferralImage from '../../../../assets/img/referral-image.webp'

const FlexWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 480px;
`

const Title = styled.h1`
  font-size: 1.5rem;
  text-align: center;
  margin-top: 0;
  color: var(--color-secondary);
  font-weight: var(--font-weight-bold);
`

const BlockButton = styled(LinkButton)`
  width: 100%;
`

const StyledImage = styled.img`
  display: block;
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
`

function MainView() {
  const history = useHistory()
  const { location } = history

  if (location.pathname.includes('/perks')) {
    history.push('/')
  }

  return (
    <Layout>
      <FlexWrapper>
        <Title>Page Not Found</Title>
        <StyledImage src={ReferralImage} alt="Page Not Found" />
        <BlockButton to="/">Redirect to Main</BlockButton>
      </FlexWrapper>
    </Layout>
  )
}

export default MainView
